<template>
  <div
    class="poster-upload pc-poster-upload"
    :style="{
      width: `${width}px`,
      height: `${height}px`,
    }"
  >
    <div
      v-if="preview"
      :style="`background-image:url(${preview})`"
      class="pic"
    />
    <template v-show="preview">
      <span>{{ text }}</span>
      <input
        ref="preview"
        accept="image/jpg, image/jpeg"
        name="poster"
        type="file"
        :data-platform="platform"
        :data-width="width"
        :data-height="height"
        :data-size="size"
        @change="handlePosterUpload"
      >
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import {
  doUpload,
} from '@/api/upload'

export default {
  name: 'UploadPreview',
  props: {
    previewUrl: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '电脑版预览图',
    },
    platform: {
      type: String,
      default: 'pc',
    },
    width: {
      type: Number,
      default: 274,
    },
    height: {
      type: Number,
      default: 154,
    },
    previewWidth: {
      type: Number,
      default: 960,
    },
    previewHeight: {
      type: Number,
      default: 540,
    },
    size: {
      type: Number,
      default: 2 * 1024 * 1024,
    },
  },
  data() {
    return {
      previewUserUpload: false,
      preview: this.previewUrl || '',
      confirmDialogText: '',
    }
  },
  computed: {
    ...mapState({
      common: (state) => {
        return {
          token: state.userInfo.token,
          open_id: state.userInfo.open_id,
        }
      },
    }),
  },
  watch: {
    previewUrl(url) {
      this.preview = url
    },
    confirmDialogText(text) {
      if (text) {
        this.$emit('error', text)
      }
      this.confirmDialogText = ''
    },
    preview(url) {
      if (this.previewUserUpload) {
        this.$emit('change', {
          url,
          platform: this.platform,
        })
      }
    },
  },
  methods: {
    checkPicWidthHeight(file, previewWidth, previewHeight) {
      const $img = document.createElement('img')
      try {
        return new Promise((resolve /* , reject */) => {
          $img.onload = () => {
            const { width, height } = $img
            if (width >= previewWidth && height >= previewHeight) {
              resolve(true)
              return
            }

            resolve(false)
          }

          $img.onerror = () => {
            resolve(true)
          }

          try {
            $img.src = URL.createObjectURL(file)
          } catch (err) {
            resolve(true)
          }
        })
      } catch (err) {
        return true
      }
    },
    handleSelectPoster() {
      this.$refs.preview.click()
    },
    async handlePosterUpload($event) {
      const $target = $event.target
      const file = $target.files && $target.files[0]
      const width = this.previewWidth
      const height = this.previewHeight
      const size = this.size

      if (!file) {
        this.handleRemovePreview()
        return
      }

      if (!file.name || !file.name.match(/\.jpg$/gi)) {
        this.$emit('error', '请上传jpg格式的预览图')
        this.handleRemovePreview()
        return
      }

      // 检查图片大小
      if ((await this.checkPicWidthHeight(file, width, height)) === false) {
        this.$emit('error', `请上传尺寸不小于${width}*${height}的预览图`)
        this.handleRemovePreview()
        return
      }

      if (file.size > size) {
        this.$emit('error', `请上传${size}M以内的预览图`)
        this.handleRemovePreview()
        return
      }

      this.previewUserUpload = true
      this.doUploadPreview(file, this.platform)
    },
    handleRemovePreview() {
      if (this.$refs.preview) {
        this.$refs.preview.value = ''
      }
    },
    async doUploadPreview(file, platform = 'pc') {
      const data = new FormData()
      data.append('open_id', this.common.open_id)
      data.append('token', this.common.token)
      data.append('file', file)
      data.append('file_type', 'preview_jpg')

      try {
        const res = await doUpload(data, {}, platform)
        if (res.data) {
          this.preview = res.data.resource_url
          this.$emit('upload', {
            url: this.preview,
            platform: this.platform,
          })
        }
      } catch (err) {
        this.confirmDialogText = err.message
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.poster-upload {
  position: relative;
  text-align: center;
  background: #F3F3F4;
  overflow: hidden;
  span {
    z-index: 1;
    position: absolute;
    left: 0;
    right: 0;
    top: 50%;
    margin-top: -8px;
    font-size: 12px;
    color: #A5A5AE;
  }
  input {
    z-index: 3;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    padding-top: 200%;
    cursor: pointer;
  }
  .pic {
    z-index: 2;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
  }
}
</style>
